import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import firebase from 'firebase'
import 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import 'materialize-css/dist/js/materialize.js'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

//create a global filter
Vue.filter('shorten', val => {
 if(!val || typeof(val) != 'string') return ''
 val = val.slice(0,20) +'...'
 return val
})
Vue.filter('ref', val => {
 if(!val || typeof(val) != 'string') return ''
 val = val.slice(7, 14)
 return val
})

new Vue({
    router,
    render: function (h) { return h(App) }
}).$mount('#app')
